
export default function(o){
  
  var s = o.sounds.tick
  
  s.sound.pause()

  s.sound.currentTime = 0
  
  s.sound.play()

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/soundTick/soundTick.js